var aston = {
  astonpages: [
    '114506831560813', //Aston Innovation
    '111962608449153', //ติ่มซำ ไอที
    '100877276218411', //Dengo IT
    '103133082829494', //เพจทดสอบ-Aston
    '104667528144994', //Oppa IT
    '109983881794432', //โปรดีดีต้องที่นี่เท่านั้น
    '101868719406062', //Super Care Center - กล้องติดรถยนต์ กล้องวงจรปิดบ้าน
    '105587935557695', //แซมมี่It168 สินค้าไอทีของดี มีประกัน ราคาโรงงาน
    '107042615440628', //TEST - ASTON
    '102071999159861', //Axon It
    '112173381765755', //Axon LifeStyle
    '101788635868577', //ดับเบิ้ลที สินค้าไอที มีประกัน
    '101740705846559', //สบายดี ไอที - ศูนย์รวมสินค้าไอที ราคาโรงงาน
    '102742292275466',
    '108253021670158', //Shopdeeไอที
    '2261615673888062',
    '1231805606976542',
    '1493632560856869',
    '2105726733070683',
    '391365474996527',
    '282419538600861',
    '229446640739626',
    '114462824560740', //IT's hot price สินค้าไอทีราคาถูก ประกัน 2 ปี
    '1422119811377985',
    '1441887002726565',
    '367229174088451',
    '701617826905112',
    '1610279989092091',
    '638403099982540',
    '104681644249934',
    '251931082395852',
    '115245059851835',
    '103782414379044',
    '104620487627501',
    '110883070374655',
    '101788984628392',
    '114106830003988',
    '114311243328338',
    '112176626873979',
    '114758919951998',
    '582769212229333', //eyewear
    '419387548804493',
    '2340579716175183',
    '100590148401358',
    '102564098201451',
    '105286034592205',
    '106043044515474',
    '106368351149754',
    '746554075685318',
    '113757453384556',
    '1410884002493027',
    '103787708076884',
    '315491435613744',
    '113507913846130',
    '101357855128536',
    '115208697016001',
    '112843187297717',
    '100629058480377',
    '102186311718644',
    '120174639836444',
    '101375865066409',
    '114036357120585',
    '104765244721811',
    '102948521573312',
    '107669508070817',
    '106674444818236',
    '112265563891753',

    '102656388405729',
    '107669508070817',
    '106674444818236',
    '105891421354304',
    '103181171964612',

    '107390324871489',
    '108150328165616',
    '100553032271028',

    '100308032336515',
    '107865658305299',
    '101476482284632',
    '103688148316639', // Here Me Pro - เฮียมีโปร
    '100174465816640', // ถูกและดีต้องที่นี่เท่านั้น
    '101446162004303', // กล้องติดรถราคาส่ง ใหญ่สุดในไทย
    '276422170840092', // กล้องติดรถดี มีคุณภาพ รับประกันทุกชิ้น
    '108799358272746', // เจริญพรไอที ถูกและดีสำหรับท่านผู้มีบุญ
    '109662734852577', //สินค้าไอทีถูกและดี ต้องที่นี่เท่านั้น

    '103910012101270', //ศูนย์รวมกล้องติดรถ กล้องติดบ้าน ของแท้ ประกันศูนย์ไทย
    '126967064820604',
    '398507690685493',
    '103395698845508', // Be Better Shop สินค้าราคาโรงงาน
    '112328994596891', // It Mall มือถือราคาถูก ส่งไว มีประกัน
    '107499118410660', // Marcar เปิดท้ายโรงงาน ราคาดี สินค้าคุณภาพ
    '105246805314716', // YAK-Kaii อยากขาย
    '103910012101270', // โปรดีไอที ศูนย์รวมสินค้าไอทีของแท้ ประกันศูนย์ไทย
    '112586544571055', // Good Tech สินค้าราคาส่ง รับตรงจากโรงงาน
    '110281881473512', // โปรเด็ดราคาดี การันตี คุณภาพ
    '106176941888239', // เฮียติดกล้อง โรงงานกล้องบ้าน กล้องรถ ไฟโซล่า
    '109531534883639', // อาจุมม่าสินค้าดี ของแท้มีประกัน
    '107272485127439', // Shopping it กล้องติดบ้าน กล้องติดรถ ถูกและดีมีประกัน
    '105239508636182', // Phone-Mart ร้านขายมือถือราคาดี เจ้าใหญ่สุดในไทย
    '105626242200212', //Axon Mall สินค้าไอที รับประก้น 2 ปี
    '102506058918744', // ไฟโซล่า โรงงานขายเอง ถูกที่สุดในไทย มีรับประกัน
    '101213306340426', // Dengo Technology ครบ คุ้มค่า

    '229777340553912', // Axon th
    '107701225462851', // Shopping it สินค้าดีราคาโรงงาน
    '1398026686918040', // Mr.kusol สินค้าไอที ประกันศูนย์ไทย ส่งไวจากโรงงาน
    '103797031892887', // โกดังไอที ถูก ดี มีประกัน
    '369623647083826', // Mister It ศูนย์รวมสินค้าไอทีชั้นนำ 
    '104650732635398', // Top Pro ถูกและดี ที่นี่ที่เดียว
    '266166777125449', // Dino It ของดี โรงงานสินค้าไอทีมาเอง
    '110466508762782', // All About It สินค้าไอทีราคาถูก มีประกัน
    '113907020925941', // BB Store ศูนย์รวมสินค้าคุณภาพ ราคาส่ง
    '103407168907563', // คุณหนูรีวิว สินค้าไอที
    '105161167964641', // โกดังสินค้าไอที ราคาโรงงาน

    '125504700655357', // Tech DD

    //test page
    // '998122266996445',
    // '1737574596477450',
    // '305321523708157'
  ],
  astonpagename: {
    114506831560813: { name: 'Aston Innovation' },
    111962608449153: { name: 'ติ่มซำ ไอที' },
    100877276218411: { name: 'Dengo IT' },
    103133082829494: { name: 'เพจทดสอบ-Aston' },
    104667528144994: { name: 'Oppa IT' },
    109983881794432: { name: 'โปรดีดีต้องที่นี่เท่านั้น' },
    101868719406062: { name: 'Super Care Center - กล้องติดรถยนต์ กล้องวงจรปิดบ้าน' },
    105587935557695: { name: 'แซมมี่It168 สินค้าไอทีของดี มีประกัน ราคาโรงงาน' },
    107042615440628: { name: 'TEST - ASTON' },
    102071999159861: { name: 'Axon It' },
    112173381765755: { name: 'Axon LifeStyle' },
    101788635868577: { name: 'ดับเบิ้ลที สินค้าไอที มีประกัน' },
    101740705846559: { name: 'สบายดี ไอที - ศูนย์รวมสินค้าไอที ราคาโรงงาน' },
    102742292275466: { name: 'Neon Flagship store' },
    108253021670158: { name: 'Shopdeeไอที' },
    1231805606976542: { name: 'Diamond corner ถูกและดี ที่นี่ที่เดียว' },
    1493632560856869: { name: 'Aston Thailand' },
    2105726733070683: { name: 'dshoppingth' },
    391365474996527: { name: 'Neon ผู้นำแสงสว่างแห่งวงการไอที' },
    282419538600861: { name: 'Dengothailand Fanpage' },
    229446640739626: { name: 'Aston Technology' },
    114462824560740: { name: "IT's hot price สินค้าไอทีราคาถูก ประกัน 2 ปี" },
    1422119811377985: { name: 'Dengothailand Shopping Online' },
    1441887002726565: { name: 'Dengotech Online Shopping' },
    701617826905112: { name: 'Bidogoo' },
    367229174088451: { name: 'บัวลอย ของดีไอที' },
    100590148401358: { name: 'บังเอส ของดีไอที' },
    105286034592205: { name: 'จาตุรงค์บงการ ของดีไอที' },
    106043044515474: { name: 'บัวลอย ฟรอยทะลุ' },
    106368351149754: { name: 'Mini bear ของดีไอที' },
    746554075685318: { name: 'BEAR It สินค้าชั้นดีที่พี่หมีแนะนำ' },
    1589840171084621: {
      name: 'BB Store Thailand สินค้าไอที ลำโพง บลูทูธ มือถือ รถยนต์'
    },
    1396503507148739: { name: 'จาตุรงค์ ของดีไอที' },
    1610279989092091: { name: 'Aston IT' },
    104681644249934: { name: 'มิสเตอร์กล้องดี' },
    638403099982540: { name: 'I.T. Shop เพจเดียวจบ ครบเรื่องไอที' },
    251931082395852: { name: 'กล้องติดรถยนต์ it center' },
    114311243328338: { name: 'สารพัดเรื่องกล้องต้อง Mr.Wow' },
    112176626873979: { name: 'Easy it สินค้าไอที ถูกและดีมีประกัน' },
    114758919951998: { name: 'Hi-tech Cam︱ตัวจริงเรื่องสินค้าไอที' },
    419387548804493: { name: 'All IT. ศูนย์รวมสินค้าไอที ของแท้ มีประกัน IP X' },
    315491435613744: { name: 'AxonTech' },
    2340579716175183: { name: 'Dengo Shock Price ของเด็ด ราคาดี ส่งฟรีทั่วไทย' },
    113757453384556: { name: 'It cam︱ตัวจริงเรื่องสินค้าไอที' },
    1410884002493027: { name: 'Likeseason' },
    103787708076884: { name: 'Tiny bear ของดีไอที' },
    113507913846130: { name: 'Super Smart It เราเลือกสิ่งที่ดีที่สุดเพื่อคุณ' },
    101357855128536: { name: 'Bear Tech สินค้าไอที มีประกัน' },
    115208697016001: { name: 'PICK-A-Boo It ไอที ทีเด็ด ครบ จบทุกเรื่องไอที' },
    112843187297717: { name: 'Cloudtech - ศูนย์รวมสินค้าไอที' },
    100629058480377: { name: 'Flazh Phone มือถือถูกและดี มีประกัน ที่นี่ที่เดียว' },
    102186311718644: { name: 'About It ศูนย์รวมกล้องติดรถ มือถือ สินค้าไอทีคุณภาพ' },
    120174639836444: { name: 'หนูดีช็อป ครบเครื่องเรื่อง Smartphone' },
    101375865066409: { name: 'มือถือราคาถูก ของแท้ ประกันศูนย์' },
    114036357120585: { name: 'EASY SmartPhone' },
    104765244721811: { name: 'I.T. Ranger ขบวนการไอที ราคาดี มีประกัน' },
    102948521573312: { name: 'IT. Style' },
    107669508070817: { name: 'ใจดี สมาร์ทโฟน ของแท้ประกันศูนย์ไทย เก็บเงินปลายทางทั่วประเทศ ' },
    106674444818236: { name: 'TWOCam กล้องวงจรปิด ไร้สาย wifi ราคาโรงงาน' },
    112265563891753: { name: 'little bear ของดีไอที ' },

    102656388405729: { name: 'IT Star ' },
    107669508070817: { name: 'ใจดี สมาร์ทโฟน' },
    106674444818236: { name: 'TWOCam' },
    105891421354304: { name: 'Neon Thailand' },
    103181171964612: { name: 'ใจดี' },

    107390324871489: { name: 'AO Center' },
    108150328165616: { name: 'It Slayer นักล่าของถูกและดี ที่นี้ที่เดียว' },
    100553032271028: { name: 'คุณนาย It ของถูก ของดี ที่นี่ที่เดียว' },

    100308032336515: { name: 'ชี้เป้ากล้อง พิกัดโปรคุ้มม' },

    107865658305299: { name: 'Micxbear gadget สินค้าไอที ของดีมีประกัน' },
    101476482284632: { name: 'Mister J สินค้าดี ไอทีเซอร์วิส' },
    103688148316639: { name: 'Here Me Pro - เฮียมีโปร' },
    276422170840092: { name: 'กล้องติดรถดี มีคุณภาพ รับประกันทุกชิ้น' },
    108799358272746: { name: 'เจริญพรไอที ถูกและดีสำหรับท่านผู้มีบุญ' },
    100174465816640: { name: 'ถูกและดีต้องที่นี่เท่านั้น' },
    101446162004303: { name: 'กล้องติดรถราคาส่ง ใหญ่สุดในไทย' },

    109662734852577: { name: 'สินค้าไอทีถูกและดี ต้องที่นี่เท่านั้น' },

    103910012101270: { name: 'ศูนย์รวมกล้องติดรถ กล้องติดบ้าน ของแท้ ประกันศูนย์ไทย' },
    126967064820604: {
      name: 'STORM Gadget & Car Accessories สินค้าไอที ลำโพง บลูทูล มือถือ และรถยนต์'
    },
    398507690685493: { name: 'Hi ไอเทมไอทีไฮเทคที่สุด' },
    103395698845508: { name: 'Be Better Shop สินค้าราคาโรงงาน' },
    112328994596891: { name: 'It Mall มือถือราคาถูก ส่งไว มีประกัน' },
    107499118410660: { name: 'Marcar เปิดท้ายโรงงาน ราคาดี สินค้าคุณภาพ' },
    105246805314716: { name: 'YAK-Kaii อยากขาย' },
    103910012101270: { name: 'โปรดีไอที ศูนย์รวมสินค้าไอทีของแท้ ประกันศูนย์ไทย' },
    112586544571055: { name: 'Good Tech สินค้าราคาส่ง รับตรงจากโรงงาน' },
    110281881473512: { name: 'โปรเด็ดราคาดี การันตี คุณภาพ' },
    106176941888239: { name: 'เฮียติดกล้อง โรงงานกล้องบ้าน กล้องรถ ไฟโซล่า' },
    109531534883639: { name: 'อาจุมม่าสินค้าดี ของแท้มีประกัน' },
    107272485127439: { name: 'Shopping it กล้องติดบ้าน กล้องติดรถ ถูกและดีมีประกัน' },
    105239508636182: { name: 'Phone-Mart ร้านขายมือถือราคาดี เจ้าใหญ่สุดในไทย' },
    105626242200212: { name: 'Axon Mall สินค้าไอที รับประก้น 2 ปี' },
    102506058918744: { name: 'ไฟโซล่า โรงงานขายเอง ถูกที่สุดในไทย มีรับประกัน' },
    101213306340426: { name: 'Dengo Technology ครบ คุ้มค่า' },

    229777340553912: { name: 'Axon th' },
    107701225462851: { name: 'Shopping it สินค้าดีราคาโรงงาน' },
    1398026686918040: { name: 'Mr.kusol สินค้าไอที ประกันศูนย์ไทย ส่งไวจากโรงงาน' },
    103797031892887: { name: 'โกดังไอที ถูก ดี มีประกัน' },
    369623647083826: { name: 'Mister It ศูนย์รวมสินค้าไอทีชั้นนำ ' },
    104650732635398: { name: 'Top Pro ถูกและดี ที่นี่ที่เดียว' },
    266166777125449: { name: 'Dino It ของดี โรงงานสินค้าไอทีมาเอง' },
    110466508762782: { name: 'All About It สินค้าไอทีราคาถูก มีประกัน' },
    113907020925941: { name: 'BB Store ศูนย์รวมสินค้าคุณภาพ ราคาส่ง' },
    103407168907563: { name: 'คุณหนูรีวิว สินค้าไอที' },
    105161167964641: { name: 'โกดังสินค้าไอที ราคาโรงงาน' },
    
    125504700655357: { name: 'Tech DD' },
  }
}
window.aston = aston



//////////////////
// WEBPACK FOOTER
// ./static/js/astonpage.js
// module id = IFZo
// module chunks = 8